module.exports = __webpack_public_path__ + "img/Feature.e469222b.jpg";